import i18n from 'l10n';
import GenericView from 'js/views/generic.view';
import Template from 'js/templates/subscriber.list.row.hbs';
import {className, on, tagName, template} from "../adapters/backbone-decorators";
import {_} from 'backboneAdapter';

@tagName("span")
@className('subscriber-row')
@template(Template)
class SubscriberListRowView extends GenericView {

    constructor(options) {
        super(options);
        this.options = options;
        this.model.set("isEnum", this.options.groupModel.get("groupType") === "enum");
        this.model.set("groupId", this.options.groupModel.get("id"));
        this.model.set("description", this.options.groupModel.get("description"));
        this.model.set("hasEmail", !!this.model.get('subscriber').email);
        this.model.set("hasSms", !!this.model.get('msisdn'));
        this.model.on('change', this.render, this); // When an attribute of the model changes value this will invoke render of this subscriber.
    }

    render() {
        const theId = this.model.get(this.model.idAttribute);
        super.render();
        $(this.el).find(".icon-info-2").parent().bind("click", function () {
            document.location.href = "#" + theId;
        });
    }

    @on('click #removeContactFromGroup')
    removeRelationship(ev) {
        ev.stopPropagation();
        const sid = this.model.get(this.model.idAttribute);
        this.options.groupModel.removeContactFromGroup(sid);
    }

    @on('click .toggle-block')
    toggleBlock() {
        const $count = $('#count-blocked');
        const count = $count.text();
        $count.text(i18n.t("contacts.countBlocked", {count: this.toggleGenericCallback(1, count, 'status')}));
    }

    @on('click .toggle-email-bounce', 'bouncedEmailGroupGId', 'email', 'Email', 'emailBounced')
    @on('click .toggle-sms-bounce', 'bouncedSmsGroupGId', 'sms', 'Sms', 'smsBounced')
    async toggleBouncingGeneric(endpoint, counterDiscriminator, dictionaryEntryDiscriminator, modelAttributeToUpdate) {
        try {
            const groupId = await $.ajaxDefaultQ({
                url: '/CampaignCloud/Group/' + endpoint,
                type: 'get',
                dataType: 'json'
            });
            if (groupId) {
                const $count = $(`#count-${counterDiscriminator}-bounced`);
                const count = $count.text();
                $count.text(i18n.t(`contacts.count${dictionaryEntryDiscriminator}Bounced`, {count: this.toggleGenericCallback(groupId, count, modelAttributeToUpdate)}));
            }
        } catch (error) {
            console.error(error);
        }
    }

    getNumber(count) {
        const number = parseInt(count);
        if (isNaN(number)) { // If the html of div is in "One something" format, parseInt produces NaN
            return 1;
        } else {
            return number;
        }
    }

    toggleGenericCallback(groupId, count, modelAttributeToUpdate) {
        if (this.model.get(modelAttributeToUpdate) === 1) {
            this.model.unblockContact(groupId);
            this.model.set(modelAttributeToUpdate, 0); // Render will be called.
            return this.getNumber(count) - 1;
        } else {
            this.model.blockContact(groupId);
            this.model.set(modelAttributeToUpdate, 1); // Render will be called.
            return this.getNumber(count) + 1;
        }
    }

    @on('click .moreOptions')
    @on('mouseleave .contactMoreOptions', _, false)
    @on('mouseenter .contactMoreOptions', _, true)
    toggleMoreOptions(e, flag) {
        e.stopPropagation();
        const el = $(e.currentTarget).find('span');
        el.toggleClass('visibleInlineBlock', flag !== undefined ? flag : !el.hasClass('visibleInlineBlock'));
    }
}

export default SubscriberListRowView;
